import { Tag } from "@/components/Common/Tag";
import {
  Card,
  Integrators,
  IntegratorsLabel,
  Shop,
  Tag as TagType,
} from "@/types/v2";
import { useMemo } from "react";
import { getTextColor } from "@/lib/utils";
import { DEFAULT_TAG_COLOR } from "@/lib/const";
import { sortTagsByShopOrder } from "@/lib/tags";
import { shouldShowLabelAsTag } from "@/lib/cards";
import { getIntegratorImage } from "@/lib/integrators";

type CardTagsProps = {
  cardData: Card;
  tags?: TagType[];
  shop?: Shop;
};
export const CardTags = ({ cardData, tags, shop }: CardTagsProps) => {
  const orderedTags = useMemo(
    () => sortTagsByShopOrder(cardData.tags ?? [], tags),
    [cardData.tags, tags]
  );
  const showLabelTag = useMemo(
    () => shouldShowLabelAsTag(cardData, shop),
    [cardData, shop]
  );
  return (
    <div className="flex flex-row flex-wrap gap-0.5">
      {showLabelTag && <RenderLabelTag cardData={cardData} shop={shop} />}
      {orderedTags.map((tag, index) => (
        <RenderTag
          key={`${tag}-${index}`}
          label={tag}
          tag={tags?.find((t) => t.label.toLowerCase() === tag.toLowerCase())}
        />
      ))}
    </div>
  );
};

const RenderLabelTag = ({
  cardData,
  shop,
}: {
  cardData: Card;
  shop?: Shop;
}) => {
  const integrator = shop?.integration ?? Integrators.tekmetric;
  return (
    <Tag
      label={cardData.label ?? ""}
      icon={
        <img
          src={getIntegratorImage(integrator)}
          alt={`${IntegratorsLabel[integrator]} label`}
          className="h-2.5 w-2.5 shrink-0"
        />
      }
      style={{
        backgroundColor: cardData.backgroundColor,
        color: getTextColor(cardData.backgroundColor),
      }}
    />
  );
};

export const RenderTag = ({ label, tag }: { label: string; tag?: TagType }) => {
  const backgroundColor = useMemo(() => tag?.customColor, [tag?.customColor]);
  const color = useMemo(
    () => getTextColor(tag?.customColor ?? DEFAULT_TAG_COLOR),
    [tag?.customColor]
  );
  return (
    <Tag
      label={label}
      style={{
        backgroundColor: backgroundColor,
        color: color,
      }}
    />
  );
};
